module.exports = __webpack_public_path__ + "media/images/arrows/twisted/orange-left2-ecc0385b0974218c70d701d1cefc48aa.svg";